import { graphql } from "@opensea/graphql"

export const VolumeFragment = graphql(`
  fragment Volume on Volume {
    usd
    native {
      symbol
      unit
    }
  }
`)
